export const BRAND = {
  name: "Just Dessert Me",
  tagline: "Watch It Freeze, Taste The Magic",
  logo: "https://customer-assets.emergentagent.com/job_rolled-bliss/artifacts/ka2s7atb_Just%20Dessert%20Me%20Logo.png",
  storefront: "https://customer-assets.emergentagent.com/job_rolled-bliss/artifacts/180wfek5_705698810_974802475398467_2025373333846857778_n.jpg",
  trailer: "https://customer-assets.emergentagent.com/job_rolled-bliss/artifacts/knf98fqo_ChatGPT%20Image%20Jun%203%2C%202026%2C%2003_47_11%20PM.png",
  specialties: ["Milkshakes", "Pancakes", "Waffles", "Rolled Ice Cream", "Desserts"],
  email: "enquiries@copperandcream.co.nz",
  phone: "07 823 2391",
  address: "113 Cambridge Road, Hillcrest, Hamilton",
  hours: "Tue – Sun · 12pm – 10pm",
  hoursDetailed: [
    { days: "Tuesday",   time: "12:00 pm – 10:00 pm" },
    { days: "Wednesday", time: "12:00 pm – 10:00 pm" },
    { days: "Thursday",  time: "12:00 pm – 10:00 pm" },
    { days: "Friday",    time: "12:00 pm – 10:00 pm" },
    { days: "Saturday",  time: "12:00 pm – 10:00 pm" },
    { days: "Sunday",    time: "12:00 pm – 10:00 pm" },
    { days: "Monday",    time: "Closed" },
  ],
  socials: {
    instagram: "https://instagram.com/Just_dessert_me",
    tiktok: "https://www.tiktok.com/@justdessertmenz",
    facebook: "https://www.facebook.com/JustDessertMeNZ",
  },
  // Hamilton local-delivery ordering link. Paste your delivery URL here
  // (e.g. Uber Eats, Menulog, DeliverEasy or your own ordering page).
  // While empty, the home-page banner shows a "Coming soon" state.
  delivery: {
    hamilton: "https://justdessertme.booknorder.co.nz",
  },
  // "Design Your Own" downloadable menu sheets. Replace empty strings with the
  // public URL of each uploaded menu file (PDF or image). While empty, the
  // button on the Menus page will show "Coming soon" and be disabled.
  designYourOwn: {
    wafflesPancakes: "https://customer-assets.emergentagent.com/job_rolled-bliss/artifacts/tfuhd3kt_Copy%20of%2050%C2%A7%2050%C2%A7%2050%C2%A7%2050%C2%A7%2051.00%2051.00.png",
    rolledIceCream: "https://customer-assets.emergentagent.com/job_rolled-bliss/artifacts/9bltpd8s_Copy%20of%2050%C2%A7%2050%C2%A7%2050%C2%A7%2050%C2%A7%2051.00%2051.00%20%281%29.png",
  },
};

// Full menu, in the order they should be displayed.
export const CATEGORIES = [
  { id: "milkshakes",        label: "Milkshakes",        inStoreOnly: true  },
  { id: "pancakes",          label: "Pancakes",          inStoreOnly: true  },
  { id: "waffles",           label: "Waffles",           inStoreOnly: true  },
  { id: "rolled-ice-cream",  label: "Rolled Ice Cream",  inStoreOnly: true  },
  { id: "desserts",          label: "Desserts",          inStoreOnly: true  },
  { id: "cookie-pies",       label: "Cookie Pies",       inStoreOnly: false },
  { id: "loaded-cookies",    label: "Loaded Cookies",    inStoreOnly: false },
  { id: "other-treats",      label: "Other Treats",      inStoreOnly: false },
];

// Only these are purchasable online.
export const ECOM_CATEGORY_IDS = new Set(["cookie-pies", "loaded-cookies", "other-treats"]);

export const SHOP_CATEGORIES = [
  { id: "all", label: "All" },
  ...CATEGORIES.filter((c) => !c.inStoreOnly),
];
